export default __webpack_public_path__ + "static/media/currencySymbol.4073e3ef.png";